module.exports = "/static/assets/424584aa0d2284485934a8edf4645566.png";